import api from '../../../api/_laboratoire'

// LAB-001 : circuit laboratoire (référentiel des statuts et suivi). Le jeton court est demandé
// à chaque appel et jamais conservé dans l'état de l'application.
export default {
    getReferentiel() {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.referentiel(token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    getSuiviDemande(demande_id) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.suiviDemande(demande_id, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    // LAB-003
    getReceptionListe(data) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.receptionListe(data, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    enregistrerReception(data) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.receptionEnregistrer(data, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    enregistrerExterne(data) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.externeEnregistrer(data, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    // LAB-004 : pièces jointes de résultat
    getDocuments(demande_id) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.documentsListe(demande_id, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    ajouterDocuments(demande_id, form_data) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.documentsAjouter(demande_id, form_data, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    getDocumentBlob(demande_id, document_id) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.documentBlob(demande_id, document_id, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    supprimerDocument(demande_id, document_id) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.documentSupprimer(demande_id, document_id, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    // LAB-005 : paillasse
    getPaillasseListe(data) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.paillasseListe(data, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    debuterAnalyse(demande_id) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.debutAnalyse(demande_id, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    // LAB-009 : fin de technique et parcours tracé d'un bon
    terminerTechnique(demande_id) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.finTechnique(demande_id, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    getParcoursBulletin(bulletin_id) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.parcoursBulletin(bulletin_id, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    // LAB-006 : validation biologique et compte rendu
    getValidationListe(data) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.validationListe(data, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    validerResultat(demande_id, data) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.valider(demande_id, data, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    renvoyerEnSaisie(demande_id, data) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.retourSaisie(demande_id, data, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    renvoyerEnTechnique(demande_id, data) {
        return api.access().then(token => api.retourTechnique(demande_id, data, token))
    },

    // LAB-007 : rectification après validation
    rectifierResultat(demande_id, data) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.rectifier(demande_id, data, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    // LAB-008 : indicateurs et registre des non-conformités
    getIndicateurs(mois) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.indicateurs(mois, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    getNonConformites(data) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.nonConformitesListe(data, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    declarerNonConformite(data) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.nonConformiteDeclarer(data, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    cloturerNonConformite(id, data) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.nonConformiteCloturer(id, data, token).then(
                    response => { resolve(response) }, error => { reject(error) }
                )
            }, error => { reject(error) })
        })
    },

    getCompteRendu(bulletin_id) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.compteRendu(bulletin_id, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    getSuiviBulletin(bulletin_id) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.suiviBulletin(bulletin_id, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    },

    // LAB-RES-001 : page « Résultats » médecins/infirmiers — suivi paginé du circuit
    getResultatsSuivi(data) {
        return new Promise((resolve, reject) => {
            api.access().then((token) => {
                api.resultatsSuiviListe(data, token).then(
                    response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    }
                )
            }, error => {
                reject(error)
            })
        })
    }
}
